<nz-modal [nzVisible]="visible" [nzTitle]="previewHeaderTpl" [nzFooter]="null" nzWidth="880px" nzCentered
  nzClassName="model-preview-modal" (nzOnCancel)="close()">

  <!-- Header -->
  <ng-template #previewHeaderTpl>
    <div class="preview-modal-header">
      <div class="preview-header-icon"><i class="fa-solid fa-cube"></i></div>
      <div class="preview-header-text">
        <div class="preview-header-title">{{ title || ('model3d.preview' | translate) }}</div>
        <div class="preview-header-meta">
          <span class="meta-chip">GLB</span>
          <span *ngIf="size">{{ formatSize(size) }}</span>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-container *nzModalContent>
    <div class="model-preview-stage">
      <!-- Stage controls -->
      <div class="stage-controls" *ngIf="isViewerReady && !previewError">
        <button type="button" class="stage-btn" [class.active]="autoRotate" (click)="autoRotate = !autoRotate"
          [nzTooltipTitle]="'model3d.auto-rotate' | translate" nzTooltipPlacement="left" nz-tooltip>
          <i class="fa-solid fa-arrows-rotate"></i>
        </button>
      </div>

      <!-- Downloading the model / booting the viewer -->
      <div *ngIf="!isViewerReady && !previewError" class="preview-state">
        <div class="preview-spinner"></div>
        <p class="preview-state-text">{{ 'model3d.preview-loading' | translate }}</p>
      </div>

      <!-- The model -->
      <model-viewer *ngIf="isViewerReady && !previewError && objectUrl" [src]="objectUrl" [alt]="title" camera-controls
        [attr.auto-rotate]="autoRotate ? '' : null" touch-action="pan-y" shadow-intensity="1" shadow-softness="0.8"
        exposure="1.05" environment-image="neutral" camera-orbit="0deg 75deg 105%" class="model-viewer-el"
        (error)="onViewerError($event)">
      </model-viewer>

      <!-- Could not render -->
      <div *ngIf="previewError" class="preview-state">
        <div class="preview-error-icon"><i class="fa-solid fa-triangle-exclamation"></i></div>
        <p class="preview-state-text">{{ 'model3d.preview-failed' | translate }}</p>
        <code class="preview-error-detail">{{ previewError }}</code>
      </div>

      <!-- Interaction hint -->
      <div class="stage-hint" *ngIf="isViewerReady && !previewError">
        <i class="fa-solid fa-up-down-left-right"></i>
        {{ 'model3d.preview-hint' | translate }}
      </div>
    </div>

    <div class="preview-footer" *ngIf="url">
      <div class="preview-url-pill">
        <i class="fa-solid fa-link"></i>
        <span class="preview-url">{{ url }}</span>
      </div>
      <div class="preview-footer-actions">
        <button type="button" class="preview-btn-copy" (click)="copyUrl($event)">
          <i class="fa-regular fa-copy"></i>
          <span>{{ 'model3d.copy-url' | translate }}</span>
        </button>
        <a class="preview-btn-icon" [href]="url" target="_blank" rel="noopener noreferrer"
          [nzTooltipTitle]="'model3d.open-url' | translate" nz-tooltip>
          <i class="fa-solid fa-arrow-up-right-from-square"></i>
        </a>
      </div>
    </div>
  </ng-container>
</nz-modal>
